<template>
  <div class="flex items-center gap-4">
    <NAvatar label="PR" size="lg" avatar="~" style="background-color:#303" class="text-white" />

    <NAvatar avatar="solid-white" label="PR" size="lg" class="rounded-md text-$c-brand-next ring-$c-brand-light" />

    <NAvatar size="2xl" class="rounded-none" src="/images/avatar.png" />
  </div>
</template>
